<template>
  <!-- HTML 정의하는 부분 -->
  <!-- 1차 퍼블리셔가 작업 영역 -->
  <!-- 2차 개발자가 Template 화 작업 진행-->
  <v-card width="6%" min-width="107" max-width="115" class="main_card p-0" v-if="setBlock">
    <v-container fluid class="pa-0">
      <v-card-title class="justify-center font-weight-bold py-0 titleClass">{{ title }}</v-card-title>
      <v-card-text class="pa-1">
        <table>
          <tr>
            <th width="30%">
              <v-avatar v-if="runCount <= 0" color="green" size="18" class="justify-center"></v-avatar>
              <v-avatar
                v-else
                @click="$emit('openPop', title, runList, 'run')"
                color="green"
                class="justify-center"
                size="18"
              ></v-avatar>
            </th>
            <th v-if="runCount <= 0" style="color:#4CAF50;" width="70%" class="text-h6 NumFont">-</th>
            <th
              v-else
              @click="$emit('openPop', title, runList, 'run')"
              style="color: #4CAF50;cursor:pointer;"
              class="text-h6 NumFont"
            >{{ runCount }}</th>
          </tr>
          <tr class="Line">
            <th>
              <v-avatar
                v-if="faultCount <= 0"
                src="@/assets/image/monitoring/mark-rd.png"
                color="red"
                size="18"
              ></v-avatar>
              <v-avatar
                v-else
                @click="$emit('openPop', title, faultList, 'fault')"
                style="cursor:pointer;"
                color="red"
                size="18"
              ></v-avatar>
            </th>
            <th v-if="faultCount <= 0" style="color: #F44336;" class="text-h6 NumFont">-</th>
            <th
              v-else
              @click="$emit('openPop', title, faultList, 'str')"
              style="color: #F44336;cursor:pointer;"
              class="text-h6 NumFont"
            >{{ faultCount }}</th>
          </tr>
          <tr>
            <th>
              <v-avatar v-if=" errorCount <= 0" color="yellow darken-2" size="18"></v-avatar>
              <v-avatar
                v-else
                @click="$emit('openPop', title, errorList, 'err')"
                style="cursor:pointer;"
                color="yellow darken-2"
                size="18"
              ></v-avatar>
            </th>
            <th v-if="errorCount <= 0" style="color:#FBC02D;" class="text-h6 NumFont">-</th>
            <th
              v-else
              @click="$emit('openPop', title, errorList, 'err')"
              style="color:#FBC02D;cursor:pointer;"
              class="text-h6 NumFont"
            >{{ errorCount }}</th>
          </tr>
        </table>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
export default {
  props: {
    stockState: {
      type: String
    },
    runCount: {
      type: Number
    },
    faultCount: {
      type: Number
    },
    errorCount: {
      type: Number
    },
    visible: {
      type: Array
    },
    sidoCode: {
      type: String
    },
    title: {
      type: String,
      default: '충청북도'
    },
    faultList: {
      type: Array
    },
    errorList: {
      type: Array
    },
    runList: {
      type: Array
    }
  },
  name: 'StockBlock',
  components: {},
  data() {
    return {
      count: 0,
      emitSet: {}
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    setBlock() {
      if (this.visible.indexOf(this.sidoCode) !== -1) {
        this.$emit('noImage', true)
        return true
      }
      return false
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
  }
}
</script>

<style  lang="scss" scoped>
.main_card {
  background-color: var(--v-sidocard-base);
  table {
    font-size: 13px;
    width: 100%;
    // font-color: white;
    border-collapse: collapse;
    tr {
      td {
        //background-color: rgb(76, 88, 112);
        text-align: center;
        padding: 0px 0px 0px 0px;
      }
      th {
        //background-color: rgb(76, 88, 112);
        text-align: center;
        padding-top: 0px;
        padding-bottom: 0px;
      }
    }
  }
}
.titleClass {
  border-bottom: 1px solid rgb(129, 148, 183);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.Line {
  border-top: 1px solid #afafaf;
  border-bottom: 1px solid #afafaf;
}
.NumFont {
  color: var(--v-btntext-base) !important;
  font-weight: bold;
}
</style>
